// extracted by mini-css-extract-plugin
export var inputContainer = "_sp-0";